import { apiV2 } from './api';

export const fetchSubscribe = (payload) => apiV2.post('/subscriptions/subscription/subscribe/', payload);
export const fetchSubscriptionProduct = () => apiV2.get('/products/trial/');
